import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class DedicatedThemeResolver implements Resolve<Promise<boolean>> {

  async resolve(): Promise<boolean> {
    if (!environment.dedicatedCss) return true;

    // Remove fallback theme immediately
    document.getElementById('fallback-theme')?.remove();

    try {
      // Fetch storage config from backend
      const res = await fetch(`${environment.baseApiUrl}api/Configuration/getDedicatedStorageConfig`);
      if (!res.ok) return true;
      const config = await res.json();
      const themeUrl = `https://${config.accountName}.file.core.windows.net/${config.container}/dedicatedcss/theme.css${config.sasToken}`;

      // Inject <link> for dedicated theme
      let link = document.querySelector('link[data-theme="dynamic-client-theme"]') as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'stylesheet';
        link.setAttribute('data-theme', 'dynamic-client-theme');
        document.head.appendChild(link);
      }
      link.onload = () => {
        document.querySelector('style[data-theme="dedicated-cache"]')?.remove();
        // Cache theme URL for instant load on next refresh (suppresses fallback flash)
        localStorage.setItem('client-theme-url', `${themeUrl}&v=cached`);
        fetch(themeUrl).then(r => r.ok ? r.text() : '').then(css => {
          if (css) localStorage.setItem('dedicated-theme-css', css);
        }).catch(() => {});
      };
      link.href = `${themeUrl}&v=${Date.now()}`;
    } catch {
      // Fallback: use cached CSS from localStorage if available
    }
    return true;
  }
}
